<template>
    <v-container fluid class="down-top-padding">
        <v-row>
            <v-col>
                <ajax-load
                    :url="$apiUrl.getForumEventUrl($route.params)"
                    :transform="response => response.data.data.items[0]"
                    v-slot="{data, resolved}"
                >
                <v-card :loading="!resolved">
                    <v-card-title>
                        {{ data?.NAME }}

                        <template v-if="resolved && data">
                            <v-spacer></v-spacer>

                            <v-icon-tooltip
                                :href="roscongressUrl.getEventUrl({code: data.CODE})"
                                icon="mdi-web-check"
                                target="_blank"
                            >
                                Открыть мероприятие на Портале
                            </v-icon-tooltip>

                            <v-icon-tooltip
                                :href="roscongressUrl.getEventBitrixUrl({id_events_bitrix: data.ID})"
                                icon="$ls-web-cog"
                                target="_blank"
                            >
                                Открыть мероприятие в Битрикс
                            </v-icon-tooltip>
                        </template>
                    </v-card-title>

                    <v-card-subtitle
                        v-if="resolved && data && data.EPS_PROJECT_ID"
                        class="d-flex align-center pb-3"
                    >
                        <span>projectId: {{ data.EPS_PROJECT_ID.VALUE }}</span>
                        <v-btn
                            icon
                            x-small
                            class="ml-1"
                            @click.stop.prevent="copyToClipboard(data.EPS_PROJECT_ID.VALUE)"
                        >
                            <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                    </v-card-subtitle>
                </v-card>
                </ajax-load>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-tabs :value="activeTab" v-if="!redirect">
                        <v-tab
                            v-for="tab in tabs"
                            :key="tab.value"
                            :to="{ name: tab.baseRoute }"
                            :tab-value="tab.value"
                        >
                            <span v-html="tab.label"></span>
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items>
                        <router-view :id-project="idProject"></router-view>
                    </v-tabs-items>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import UserAuth from "@/mixins/UserAuth";
    import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
    import roscongressUrl from "@/utils/roscongressUrl";
    import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";
    import Clipboard from "@/mixins/Clipboard";

    export default {
        name: "ForumEventSessions",
        components: {
            VIconTooltip,
            AjaxLoad,
        },
        mixins: [UserAuth, Clipboard],
        data() {
            return {};
        },
        computed: {
            roscongressUrl() {
                return roscongressUrl;
            },
            redirect() {
                return !!this.$route.meta.redirectIndex;
            },
            event() {
                return this.$store.getters.breadCrumbs.event;
            },
            idProject() {
                return this.event?.EPS_PROJECT_ID?.VALUE;
            },
            // - baseRoute: имя родительского маршрута,
            tabsMap() {
                return {
                    quotes: {
                        value: "quotes",
                        baseRoute: "ForumEventQuotes",
                        label: "Цитаты",
                        condition: () => !!this.idProject
                    },
                    wordclouds: {
                        value: "wordclouds",
                        baseRoute: "ForumEventWordclouds",
                        label: "Облака смыслов",
                        condition: () => !!this.idProject
                    },
                    digests: {
                        value: "digests",
                        baseRoute: "ForumEventDigests",
                        label: "Дайджесты",
                        condition: () => !!this.idProject
                    },
                    pdf: {
                        value: "pdf",
                        baseRoute: "ForumEventPdf",
                        label: "Итоги дня",
                        condition: () => !!this.idProject
                    },
                    sessions: {
                        value: "sessions",
                        baseRoute: "ForumEventSessions",
                        label: "Сессии",
                        condition: () => true
                    },
                    settings: {
                        value: "settings",
                        baseRoute: "ForumEventSettings",
                        label: "Настройки",
                        condition: () =>
                            this.idProject &&
                            this.user.permissions.byModule.users2projects.canRead
                    }
                };
            },
            tabs() {
                return Object.values(this.tabsMap).filter(tab =>
                    typeof tab.condition === "function" ? tab.condition() : !!tab.condition
                );
            },
            // Активный таб определяется по тому, какие родительские маршруты присутствуют в $route.matched.
            // Если среди них есть вкладка, возвращаем её value, иначе – по умолчанию quotes или sessions.
            activeTab() {
                const map = this.tabsMap;
                const matchedNames = this.$route.matched
                    .map(r => (r.name ? r.name.toLowerCase() : ""))
                    .filter(Boolean);
                for (let key in map) {
                    if (matchedNames.includes(map[key].baseRoute.toLowerCase())) {
                        return map[key].value;
                    }
                }
                return map[this.idProject ? 'quotes' : 'sessions'].value;
            }
        },
        watch: {
            event() {
                this.doRedirect();
            },
            redirect() {
                this.doRedirect();
            },
        },
        methods: {
            doRedirect() {
                if (this.redirect) {
                    this.$router.replace({name: this.idProject ? 'ForumEventQuotes' : 'ForumEventSessions'});
                }
            },
        },
    };
</script>

<style scoped>
    .v-tabs {
        border-bottom: 1px solid #c0c0c044;
    }
</style>
